define("SuiteDB.SDBYMM.SDBYMM", ["SuiteDB.SDBYMM.SDBYMM.View"], function (
  SDBYMMView
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      //disables the extension to prevent problems running locally, should be removed if the extension has to be activated
      return;
      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");

      if (layout) {
        layout.addChildView("SDB.YearMakeModel", function () {
          return new SDBYMMView({ container: container });
        });
      }
    },
  };
});
